import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    input: {
      width: '100%',
    },
    marginTop: {
      marginTop: theme.spacing(3),
    },
  };
};
